import { enumeratedLifeCycle, readStates, updateStates } from '@/constants/lifecycle';

const announcementActions = {
  FETCH_ANNOUNCEMENTS: 'FETCH_ANNOUNCEMENTS',
  SHOW_ANNOUNCEMENTS: 'SHOW_ANNOUNCEMENTS',
  CLOSE_ANNOUNCEMENTS: 'CLOSE_ANNOUNCEMENTS',
  PREVIOUS_ANNOUNCEMENT: 'PREVIOUS_ANNOUNCEMENT',
  NEXT_ANNOUNCEMENT: 'NEXT_ANNOUNCEMENT',
};

export const announcementLifeCycle = [...enumeratedLifeCycle];

export const announcementLevels = {
  information: 'info circle',
  warning: 'warning sign',
  critical: 'remove circle',
};

export const announcementStates = {
  ...readStates,
  ...updateStates,
};

export default announcementActions;
